import {
  GET_SUMMARY_REQUEST,
  GET_SUMMARY_SUCCESS,
  GET_SUMMARY_ERROR
} from "../actions/orderSummaryActions";

import { CLEAR_ORDER } from "../actions/orderActions";

import { SELECT_DATE } from "../actions/ticketsActions";
import { GET_EVENT_SUCCESS } from "../actions/eventActions";

const initialState = {
  data: null,
  eventDate: null,
  loading: false,
  error: false
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_ORDER: {
      return initialState;
    }
    case GET_SUMMARY_REQUEST:
      return {
        ...state,
        data: null,
        loading: true,
        error: false
      };
    case GET_SUMMARY_SUCCESS:
      return {
        ...state,
        data: action.summary,
        loading: false,
        error: false
      };
    case GET_SUMMARY_ERROR:
      return {
        ...state,
        data: null,
        loading: false,
        error: action.error
      };
    case SELECT_DATE: {
      return {
        ...state,
        eventDate: action.dateDisplay
      };
    }
    case GET_EVENT_SUCCESS:
      if (!action.event.validDates || !action.event.validDates.length){
        return {
          ...state
        }
      }
      return {
        ...state,
        eventDate: action.event.validDates[0].display
      };
    default:
      return state;
  }
};
export default { initialState, reducer}


// WEBPACK FOOTER //
// ./state/reducers/orderSummaryReducer.js